<template>
    <div class="w-full my-4 cursor-pointer">
        <div class="flex justify-between items-center shadow-sm  py-4" @click="toggleAccordion">
            <p class="text-kb-pg-cyan font-bold">{{ label }} </p>
            <span>
                <svg :class="{ '!rotate-0': toggle === true }" data-accordion-icon class="w-3 h-3 rotate-180 shrink-0" aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                    stroke-width="2" d="M9 5 5 1 1 5" />
                                            </svg>
            </span>
        </div>
        <div class="py-5 h-0 hidden" :class="{ '!h-full !flex': toggle === true }">
            <slot />
        </div>
    </div>
</template>

<script>

export default {
    name: 'Accordion',
    props: {
        label: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        }
    },
    components: {
        
    },
    data(){
        return {
            toggle: false,
        }
    },
    methods: {
        toggleAccordion(){
            this.toggle = !this.toggle
        }
    },
    computed: {

    },
    created(){

    }
}

</script>